import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=fe0bec62&scoped=true"
import script from "./NotificationContent.vue?vue&type=script&lang=js"
export * from "./NotificationContent.vue?vue&type=script&lang=js"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=fe0bec62&prod&lang=scss&scoped=true"
import style1 from "./NotificationContent.vue?vue&type=style&index=1&id=fe0bec62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0bec62",
  null
  
)

export default component.exports